import type { AiWallUpsell } from '../aiWall/aiWall.types'
import { createAiWallUpsell } from '../aiWall/createAiWallUpsell'
import type { CartUpsellDefinition } from '../cartUpsells.registry'
import type { CartUpsellId, CartUpsellOffer } from '../cartUpsells.schemas'
import {
  createPetAiWallOfferSchema,
  type PetAiWallOffer,
} from './petAiWall.schemas'
import {
  getPetAiWallAnalyticsProps,
  trackPetCandidateFound,
} from './petAiWallAnalytics'
import { pickPetCandidate, type PetSpecies } from './petCandidate'
import { getPetThumbCrop } from './petThumbCrop'

export type PetAiWallUpsellId = {
  [Id in CartUpsellId]: CartUpsellOffer<Id> extends PetAiWallOffer ? Id : never
}[CartUpsellId]

export type PetAiWallUpsell<Id extends PetAiWallUpsellId> = AiWallUpsell<Id> & {
  cardTitleKeys: Record<PetSpecies, string>
}

export function createPetAiWallUpsell<Id extends PetAiWallUpsellId>(
  upsell: PetAiWallUpsell<Id>
): CartUpsellDefinition<Id> {
  return createAiWallUpsell(upsell, {
    findCandidate: pickPetCandidate,
    getSourcePhotos: ({ photo }) => [photo],
    getGenerationFields: ({ photo, petBox, species }) => ({
      sourcePhotoUids: [photo.uid],
      sourcePetBox: petBox,
      sourcePetSpecies: species,
      sourceUploadSrc: photo.uploadSrc,
    }),
    getCardTitleKey: ({ sourcePetSpecies }) =>
      upsell.cardTitleKeys[sourcePetSpecies],
    offerSchema: createPetAiWallOfferSchema(upsell),
    trackCandidateFound: trackPetCandidateFound,
    getSourceAnalyticsProps: getPetAiWallAnalyticsProps,
    getSourceCrop: (offer, sourcePhoto) =>
      getPetThumbCrop(offer.sourcePetBox, sourcePhoto),
  })
}
